export class AlgoliaValidUntilError extends Error {}

export function isValidUntilError(error: Error) {
  return error.message?.includes('validUntil');
}
